import React from 'react';
import AircraftTypes from '../Form/AircraftTypes';
import CharterType from '../Form/CharterType';
import ClientSelector from '../Form/ClientSelector';
import DangerousGoods from '../Form/DangerousGoods'
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import FlightRoute from './FlightRoute';
import SupplierSelector from '../Form/SupplierSelector';
import { Row, Col } from 'reactstrap';
import { FormLabel } from '../Form/FormLabel';
import ClientDetailsCard from '../Cards/ClientDetailsCard'
import { ErrorMessage, useFormikContext } from 'formik';
import { endpoints } from '../../utils/Constants';
import SelectCurrency from '../Form/SelectCurrency';
import Inexclusions from "../Form/Inexclusions";
import { useAuth } from '../../Services/AuthContext';
import { showDateTimeUTC } from '../../utils/Helpers';

import { FormGroup, Button } from 'reactstrap';
import SelectSetting from '../Form/SelectSetting';
import SupplierDetail from '../Cards/SupplierDetail';
import CompareFormValue from '../Form/CompareFormValue';
import useCheckMobileScreen from '../../utils/Hooks/useCheckMobileScreen';
import { useFetchCached } from '../../Services/fetchApi';
import { useHistory } from 'react-router-dom';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useEdit } from '../../Services/EditContext';
import { padStart } from 'lodash';
import RoutesSummary from './RoutesSummary';
import FlightTimeSummary from './FlightTimeSummary';


const CharterRequestDetail = (props) => {
    const { newRequest, compare, noEdit, route, parentRoute } = { ...props };
    const [auth] = useAuth();
    const { values } = useFormikContext();
    const supplierChange = compare && (values.supplierInitiated || values.status === "Pending Supplier");
    const clientChange = compare && (!values.supplierInitiated && values.status !== "Pending Supplier");
    const isMobile = useCheckMobileScreen();
    const history = useHistory();
    const [edit] = useEdit();
    const viewChanged = () => {

        const newRoute = parentRoute + '/' + values.changeCharterRequestId;
        history.push(newRoute);
    }
    const viewPrevious = () => {

        const newRoute = parentRoute + '/' + values.lastVersion;
        history.push(newRoute);
    }
    const [charterTypes, loadingCharterTypes, errorCharter] = useFetchCached(endpoints.getCharterType);
    const placeBid = values.bid ? true : false;
    return (<React.Fragment>
        {values.changePending ? values.status === 'Superceded' ? <h6>This charter has been superceded <Button color='primary' onClick={viewChanged}>View Changed Charter</Button></h6> : <h3>There is a change pending for this record</h3> : null}
        {values.lastVersion ? <h6>This charter has changed <Button onClick={viewPrevious}>View Previous Version</Button></h6> : null}

        {auth.role !== 'Supplier' || values.status === 'Approved' ? <ClientDetailsCard route={route} charterDetails={values} /> : null}
        {!clientChange && !supplierChange && (placeBid || values.bidderId) ? <SupplierSelector route={route} id='bidderId' name='bidderId' /> : <SupplierDetail route={route} supplier={values.supplier} />}
        {!clientChange && !supplierChange && newRequest ? <ClientSelector all route={route} id='clientId' name='clientId' noEdit={noEdit} /> : <ClientDetailsCard route={route} />}
        {values.changePending ? <h5>There is a change pending for this charter request.</h5> : null}
        <Row>
            <Col>

                <AircraftTypes compare={compare} id='preferredAircraft' label='Preferred Aircraft' list={charterTypes?.aircraftTypes} noEdit={noEdit || supplierChange} />

            </Col>

        </Row>
        {!newRequest && (values.specialRequests || clientChange) ? <FormInput id='specialRequests' label='Special Requests' type='textarea' noEdit={!clientChange && (noEdit || supplierChange || placeBid)} /> : null}
        <CharterType placeBid={placeBid} supplierChange={supplierChange} compare={compare} charterTypes={charterTypes} noEdit={noEdit || supplierChange} />
        {values.status === "Confirmed" || values.status === "Finished" ? <FlightTimeSummary /> : null}
        {auth.role === "Admin" && values.routes instanceof Array ? <RoutesSummary /> : null}
        {loadingCharterTypes ? <LoadingAnimation height={50} /> : null}
        {errorCharter ? <h6>Error Loading Charter Types</h6> : null}
        <FlightRoute noEdit={noEdit} placeBid={placeBid} newRequest={newRequest} compare={compare} />


        <Row>
            {newRequest || values?.status === "Live" || values?.status === "Pending" ? <Col md='4' xs='4'>
                {(edit && !noEdit) || newRequest || values?.urgent ? <BooleanInput style={!newRequest && !edit && !noEdit ? { color: 'red' } : {}} id='urgent' label='Urgent - within 24 hours' noEdit={noEdit} /> : null}
            </Col> : null}
            {newRequest ? <Col md='4' xs='4'>
                <FormInput id='biddingTimeSpanHours' label='Bidding To Close in: (Hours)' type='number' noEdit={noEdit} suffix='hrs' />
            </Col> : null}

        </Row>
        <Row>
            <Col>
                {newRequest ? <FormInput id='specialRequests' label='Special Requests' type='textarea' /> : null}
            </Col>
        </Row>
        {values.status === "Confirmed" || values.status === "Closed" ? <>styff</> : null}
        {placeBid || supplierChange ? <React.Fragment>

            {placeBid || supplierChange || values.notes ? <FormInput compare={compare} id='notes' label='Notes for customer' type='textarea' noEdit={clientChange} /> : null}

            {!isMobile ? <Row>
                <Col md='3' xs='6'>
                    <SelectSetting endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
                </Col>
                <Col md='3' xs='6'>
                    <Inexclusions noEdit={clientChange} />
                </Col>
                <Col md='3' xs='6'>
                    <SelectCurrency id='currency' label='Currency' noEdit={clientChange} />
                </Col>
                <Col md='3' xs='6'>
                    <Col >
                        <FormInput id='price' label='Price (EX GST)' type='number' noEdit={clientChange} />
                    </Col>
                    {auth.role === 'Admin' && values.withMargin ? <Col>
                        <FormGroup><FormLabel style={{ display: 'block' }}>{'With Margin'}</FormLabel>
                            <ErrorMessage name={'withMargin'} />
                            <CompareFormValue id='withMargin' type='currency' style={{ display: 'block' }} />

                        </FormGroup>
                    </Col> : null}
                </Col>

            </Row> : <React.Fragment><Row>
                <Col md='3' xs='6'>
                    <SelectSetting endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
                </Col>
                <Col md='3' xs='6'>
                    <Inexclusions noEdit={clientChange} />
                </Col>
            </Row><Row>
                    <Col md='3' xs='6'>
                        <SelectCurrency id='currency' label='Currency' noEdit={clientChange} />
                    </Col>
                    <Col md='3' xs='6'>
                        <Col >
                            <FormInput id='price' label='Price (EX GST)' type='number' noEdit={clientChange} />
                        </Col>
                        {auth.role === 'Admin' && values.withMargin ? <Col>
                            <FormGroup><FormLabel style={{ display: 'block' }}>With Margin</FormLabel>
                                <ErrorMessage name={'withMargin'} />
                                <CompareFormValue id='withMargin' type='currency' style={{ display: 'block' }} />

                            </FormGroup>
                        </Col> : null}
                    </Col>


                </Row>
            </React.Fragment>}



        </React.Fragment> : null}
        <DangerousGoods compare={compare} dangerousGoodsList={charterTypes?.dangerousGoods} noEdit={noEdit || supplierChange} />
        {values.biddingEndsAt ? < div style={{ fontSize: 'small' }}>Bidding Ends At:{showDateTimeUTC(values.biddingEndsAt)}</div> : null}
    </React.Fragment>)
};

export default CharterRequestDetail;
